<!-- 销售流水 -->
<template>
   <div class='page_content'>
      <div class="page_content_top">
         <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign" :buttonFlag="false"></v-button>
         <div class="page_content_top_line">
            <el-form :inline="true" label-width="100px" :model="getRequestData" class="demo-form-inline" v-if="pageShowData.searchList" size="mini">
               <el-form-item :label="formOneValue.showField" v-for="(formOneValue, formOneKey) in pageShowData.searchList" :key="formOneKey">
                  <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                  <!-- 开始时间 -->
                  <el-date-picker v-if="formOneValue.entityField == 'start'" size="mini" class="form_codition" v-model="getRequestData[formOneValue.entityField]" format="yyyy 年 MM 月 dd 日" value-format="timestamp"
                                  type="date" placeholder="选择日期"></el-date-picker>
                  <!-- 结束时间 -->
                  <el-date-picker v-else-if="formOneValue.entityField == 'end'" @change="changeTime" size="mini" class="form_codition" v-model="getRequestData[formOneValue.entityField]" format="yyyy 年 MM 月 dd 日"
                                  value-format="timestamp" type="date" placeholder="选择日期"></el-date-picker>
                  <!-- 检索方案 -->
                  <el-input v-else-if="formOneValue.fieldType == 'search'" @clear="clear(formOneValue.setField)" class="form_codition" clearable v-model="getRequestData[formOneValue.entityField]"
                            @keyup.enter.native="openSearch('fm', formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)">
                     <el-button @click="openSearch('fm', formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"></el-button>
                  </el-input>
                  <el-select clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'" class="form_codition" v-model="getRequestData[formOneValue.entityField]" placeholder="请选择">
                     <el-option label="全部" value=""></el-option>
                     <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.value" :value="item.key">
                     </el-option>
                  </el-select>
                  <el-input clearable v-else v-model.trim="getRequestData[formOneValue.entityField]" size="mini" class="form_codition" :maxlength="$store.state.inputLength"></el-input>
               </el-form-item>
               <el-form-item>
                  <el-button type="primary" size="mini" @click="searchData">查询</el-button>
               </el-form-item>
               <!-- <el-form-item v-if="returnData.list.length > 0">
                  <div style="font-size: 14px;text-align: right;">合计：<span style="color:red;font-size: 16px">{{
                totalMoney }}</span></div>
               </el-form-item> -->
            </el-form>

         </div>
      </div>
      <div class="page_content_center">
         <el-table v-if="pageShowData.list" @selection-change="handleSelectionChange" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row
                   size="mini">
            <!-- 主表单 -->
            <el-table-column type="selection" width="40"></el-table-column>
            <template v-for="(tableValye, tableKey) in pageShowData.list">
               <el-table-column align="center" v-if="tableValye.isShow == 1" :key="tableKey" :prop="tableValye.entityField" :label="tableValye.showField"
                             show-overflow-tooltip :min-width="tableValye.fieldWeight">
               <template slot-scope="scope">
                  <!-- 开票日期 -->
                  <template v-if="tableValye.fieldType == 'date'">
                     <span v-if="scope.row[tableValye.entityField]">
                        {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                     </span>
                  </template>
                  <span v-else-if="tableValye.isRift == 1">
                     <a @click="toDetail(scope.row[tableValye.riftField])">{{
                scope.row[tableValye.entityField] }}</a>
                  </span>
                  <el-tag v-else-if="tableValye.fieldType == 'formatter'" size="mini">
                     {{ $common.getIsGsp(tableValye.formatterContent, scope.row[tableValye.entityField]) }}</el-tag>
                  <span v-else>{{ scope.row[tableValye.entityField] }}</span>

               </template>
            </el-table-column>
            </template>
         </el-table>
      </div>
      <div class="page_content_bottom">
         <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>

      </div>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
         <SearchScheme ref="searchScheme" :id="seId" :smId="smId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <printPlan ref="printPlan"></printPlan>
      <!-- 自定义设计 -->
      <customDesign ref="customDesign"></customDesign>
      <el-dialog v-if="changeCm" title="修改客户名称" :visible.sync="changeCm" width="400px%">
         <el-form label-width="100px" @submit.native.prevent :inline="true">
            <el-row>
               <el-form-item label="客户名称">
                  <label slot="label" :style="$common.labelStyle('客户名称')" v-html="'客户名称'"></label>
                  <el-tooltip class="item" :disabled="sendData.cmName == null || sendData.cmName == '' ? true : false || sendData.cmName.length <= 9" effect="dark" :content="sendData.cmName" placement="bottom-start">
                     <el-input @keyup.enter.native="openSearch('ed', '3391151360249856', 0, 'cmName', 'cmName,cmId')" class="form_codition" v-model.trim="sendData.cmName" clearable>
                        <el-button @click="openSearch('ed', '3391151360249856', 0, 'cmName', 'cmName,cmId')" slot="append" icon="el-icon-search"></el-button>
                     </el-input>
                  </el-tooltip>
               </el-form-item>
               <el-form-item label="金额">
                  <label slot="label" :style="$common.labelStyle('金额')" v-html="'金额'"></label>
                  <el-input class="form_codition" type="number" v-model.trim="sendData.money" clearable></el-input>
               </el-form-item>
            </el-row>
         </el-form>
         <span slot="footer" class="dialog-footer">
            <el-button @click="changeCm = false">取 消</el-button>
            <el-button @click="confirmUp" type="primary">确 定</el-button>
         </span>
      </el-dialog>
      <el-dialog title="导入" v-if="importShow" :visible.sync="importShow" width="30%" append-to-body modal-append-to-body>
         <initDataUpload v-if="importShow" :url="url" :importType="importType" @fileSuccess='fileSuccess' @closeExcel="closeExcel">
         </initDataUpload>
      </el-dialog>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../../byComponents/SearchScheme.vue"
import cashFlow from './cashFlow';
export default {
   //import引入的组件需要注入到对象中才能使用
   components: {
      SearchScheme
   },
   data() {
      //这里存放数据
      return {
         totalMoney: 0,
         actionType: 0,
         tableHeight: 0,
         getRequestData: {
            "page": 1,
            "rows": 30,
            start: new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000,
            end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,
            cmId: '',
            cmName: '',
            coId: '',
            coName: "",
         },
         returnData: {
            pages: 0, // 总页数
            total: 0, // 总条数
            pageNum: 0, // 当前页数
            list: []
         },
         buttonList: [],

         pageShowData: cashFlow,
         formDataList: null,
         selectedDataIndex: 0,
         multipleSelection: [],
         seTitle: "", //检索
         DialogVisible: false,
         seWidth: '0',
         seId: 0,
         smId: 0,
         sField: '',
         toField: "",
         parentSearchData: {},
         changeCm: false,
         ormId: '',
         sendData: {
            cmName: '',
            cmId: '',
            money: 0,
            id: "",
         },
         ormId: JSON.parse(sessionStorage.getItem('userInfo')).ormId,
         importShow: false,
         importType: "",
         url: "",
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      'getRequestData.smName': {
         handler: function (newValue, oldValue) {
            if (newValue == '') {
               this.getRequestData.cmId = ''
            }
         },
         deep: true,
      },
      'getRequestData.smName': {
         handler: function (newValue, oldValue) {
            if (newValue == '') {
               this.getRequestData.cmId = ''
            }
         },
         deep: true,
      }
   },
   created() {
      this.requesUrl = this.$store.getters.getConfig.requestUrl;
      this.ormId = sessionStorage.getItem('ormId')
      this.getPageInfo()
   },
   //方法集合
   methods: {
      // 勾选明细
      handleSelectionChange(val) {
         this.multipleSelection = val;
      },
      async confirmUp() {
         let responseData = await this.$http.cashFlowupdate(
            this.sendData
         )
         if (responseData.status == 200) {
            this.$message.success(responseData.message)
            for (const key in this.sendData) {
               this.sendData[key] = ''
            }
            this.changeCm = false
            this.getDataList()
         } else {
            this.$message({
               message: responseData.message,
               type: 'error'
            });
         }
      },
      //表格数据写入excel
      exportExcel(arrName, listName, title) {
         this.$common.exportData(this[arrName], this[listName], title)
      },
      // 记录汇总
      recordSummary(arrName, listName, title) {
         this.$refs.recordSummary.openBox(this[arrName], this[listName], title)
      },
      // 记录过滤
      recordFiltering(arrName, listName, title) {
         this.$refs.recordFiltering.openBox(this[arrName], this[listName], title)
      },
      closeExcel(refresh) {
         this.dialogExcel = false
         if (refresh) this.getDataList()
      },
      // 监听子组件   导入excel 成功
      fileSuccess(val) {
      },
      // 导入EXCEL
      handleExcel() {
         this.dialogExcel = true;
      },
      changeTime(val) {
         if (val) {
            var time = val + 24 * 60 * 60 * 1000 - 1;
            this.getRequestData.end = time;
         }
      },
      // 点击穿透字段 传参单号
      toDetail(orderId) {
         if (orderId) {
            // 设置为true 打开穿透组件首页    
            var isPenetrate = true
            // 设置缓存 存入点击单号
            this.resetSetItem('penetrateOrderId', orderId);
            // 与父级跨域通信 传递isPenetrate参数
            window.parent.postMessage({ //向窗口发送MessageEvent消息
               cmd: 'returnFormJson',
               params: {
                  isPenetrate
               } //参数
            }, '*');
         }
      },
      // 检索Id, 索引(表格中), 标识
      openSearch(toField, sId, index, type, sField) {
         this.DialogVisible = true;
         this.seId = sId;
         this.sField = sField;
         this.toField = toField;
         this.parentSearchData = {}
         if (toField == 'fm') {
            this.parentSearchData[type] = this.getRequestData[type];
         } else {
            this.parentSearchData[type] = this.sendData[type];
         }
      },
      //检索带回数据
      changeInputModel(val) {
         console.log('返回', val);
         if (val != "" || val != undefined) {
            this.DialogVisible = false;
            this.paramValue(val);
         }
      },
      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(",");
         if (this.toField == 'fm') {
            arr.forEach((item) => {
               this.getRequestData[item] = val[item];
            });
         } else {
            arr.forEach((item) => {
               this.sendData[item] = val[item];
            });
         }
      },
      getSeWidth(e) {
         // console.log(e);
         this.seWidth = e + "%";
      },
      getWidth(e) {
         // console.log(e);
         this.exWidth = e + "%";
      },
      getSearchName(e) {
         // console.log(e);
         this.seTitle = e;
      },

      isShowData(name, value) {
         switch (name) {
            case 'customerList':
               var dataInfo = sessionStorage.getItem('selectCustomerData')
               if (dataInfo) {
                  dataInfo = JSON.parse(dataInfo)
                  this.getRequestData.smId = dataInfo.smId
                  this.getRequestData.smName = dataInfo.smName
               }

               break;

            default:
               this.getRequestData[name] = value

         }
      },
      //获取表头信息
      async getPageInfo() {
         var obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
         for (const key in obj) {
            this.$set(this.getRequestData, key, obj[key])
         }
         this.getDataList();
         this.getButtonList();
      },
      clear(val) {
         if (val) {
            var arr = val.split(",")
            arr.forEach(item => {
               this.$set(this.getRequestData, item, "")
            })
         }
      },
      // 动作集合
      async actionSet(actionData) {
         console.log('actionSet', actionData);
         switch (actionData.actionType) {
            case 0:
               this.exportTemplate()
               break;
            case 1:
               this.importType = 'cashFlowexportCashFlow'
               this.url = 'cashFlow/exportCashFlow'
               this.importShow = true
               break;
            case 2:
               this.delDataAction()
               break;
            case 3:
               if (this.returnData.list.length < 1) {
                  this.$message({
                     message: "暂无数据",
                     type: "error",
                  });
                  return false;
               }
               if (this.multipleSelection.length != 1) {
                  this.$message({
                     message: "请先选中要操作的数据",
                     type: "error",
                  });
                  return false;
               }
               this.sendData.cmId = this.multipleSelection[0].cmId
               this.sendData.cmName = this.multipleSelection[0].cmName
               this.sendData.money = this.multipleSelection[0].money
               this.sendData.id = this.multipleSelection[0].id
               this.changeCm = true
               break;
         }
      },
      // 触发组件的提交
      fileSuccess(val) {
      },
      // 关闭弹窗
      closeExcel(val) {
         this.importShow = false
         if (val) this.getDataList()
      },
      exportTemplate() {
         window.location.href = `${window.global_config.BASE_URL}/cashFlow/importTemplate`
      },
      // 删除数据
      delDataAction() {
         if (this.returnData.list.length < 1) {
            this.$message({
               message: "暂无数据",
               type: "error",
            });
            return false;
         }
         if (this.multipleSelection.length == 0) {
            this.$message({
               message: "请先选中要操作的数据",
               type: "error",
            });
            return false;
         }
         this.$confirm('确定删除该数据吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
         }).then(async () => {
            let responseData = await this.$http.cashFlowdelete({ ids: this.multipleSelection.map(item => item.id) })
            if (responseData.status == 200) {
               this.$message({
                  type: 'success',
                  message: '删除成功!'
               });

               this.getDataList()
            } else {
               this.$message({
                  message: responseData.message,
                  type: 'error'
               });
            }

         }).catch(() => { });
      },
      openFormDesign() {
         let pathInfo = parent.getMenuInfo(this.$route.path)
         this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
      },
      showPrintPlan() {
         var dataInfo = this.returnData.list[this.selectedDataIndex]
         if (!dataInfo) {
            this.$message({
               message: '请先选中要操作的数据',
               type: 'error'
            });
            return false
         }
         // 调用全局方法 判断Websocket是否连接
         if (this.$printSocketApi.printExeMsg() != false) {
            // 选中的数据
            var info = this.returnData.list[this.selectedDataIndex]
            this.$refs.printPlan.openDia(info.woamId)
         } else {
            return
         }
      },

      // 数据搜索
      searchData() {
         this.getRequestData.page = 1
         this.getDataList()
      },
      // 数据翻页
      setDataPageNumber(val) {
         this.getRequestData.page = val
         this.getDataList()
      },

      // 切换显示条数
      setDataPageSize(val) {
         this.getRequestData.page = 1
         this.getRequestData.rows = val
         this.getDataList()
      },

      // 获取数据列表
      async getDataList() {
         let responseData = await this.$http.cashFlowqueryList(this.getRequestData)
         // console.log(responseData);
         if (responseData && responseData.status == 200) {
            let resData = JSON.parse(JSON.stringify(responseData))
            this.returnData.list = resData.result.list
            this.returnData.total = resData.result.total
            this.selectedDataIndex = 0
         } else {
            this.$message({
               message: responseData.message,
               type: 'error'
            });
         }
      },

      // 获取按钮权限
      async getButtonList() {
         this.buttonList = await this.$common.getActionButton()
         
      },
//获取状态
      getIsGsp(str, val) {
         try {
            str && str.replace(/\\/g, '')
            let arr = JSON.parse(str)
            let len = arr.length
            let newStr = ''
            for (let i = 0; i < len; i++) {
               if (arr[i].key === val) {
                  newStr = arr[i].value
                  break;
               }
            }
            return newStr
         } catch (ex) {
            return str
         }
      },

   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() { },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped></style>